 import { createContext, useEffect } from "react";
import { appReducer, initialAppState } from "../reducers/app";
import useApp from "../hooks/useApp";
import { useUser } from "../hooks/useUser";

export const AppContext = createContext();

const USER_INACTIVITY_THRESHOLD = 30000; 

export const AppProvider = ({ children }) => {
   
    const [appState, app] = useApp(appReducer, initialAppState);
    const {userService} = useUser(-1);

    useEffect(() => {
        app.setupDefault();

        let inactivityTimer;

  
        const handleVisibilityChange = () => {
            const isTabActive = document.visibilityState === "visible";
            localStorage.setItem('isTabActive', isTabActive ? 'true' : 'false');
        };

        const resetInactivityTimer = () => {
            localStorage.setItem('isTabActive', 'true');
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                localStorage.setItem('isTabActive', 'false');
            }, USER_INACTIVITY_THRESHOLD);
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener('mousemove', resetInactivityTimer);
        window.addEventListener('mousedown', resetInactivityTimer);
        window.addEventListener('keypress', resetInactivityTimer);
        window.addEventListener('scroll', resetInactivityTimer);
        window.addEventListener('touchstart', resetInactivityTimer);

         resetInactivityTimer();

         const ticker = setInterval(() => {
            const isTabActive = localStorage.getItem('isTabActive') === 'true';
            const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');

            if (isTabActive && isLoggedIn) { 
                
              userService.ping()
            
          } else {
 
          }
        }, USER_INACTIVITY_THRESHOLD);

         
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener('mousemove', resetInactivityTimer);
            window.removeEventListener('mousedown', resetInactivityTimer);
            window.removeEventListener('keypress', resetInactivityTimer);
            window.removeEventListener('scroll', resetInactivityTimer);
            window.removeEventListener('touchstart', resetInactivityTimer);
            clearInterval(ticker);
            clearTimeout(inactivityTimer);
        };
    }, []);  

    const value = {
        appState: appState,
        app: app
    };
  
    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};
